console.log("Design popup JS loaded");

document.addEventListener("DOMContentLoaded", function () {

  let selectedSide     = "front";
  let sameDesign       = false;
  let lastUploadedSide = null;
  let designs          = { front: null, back: null };

  // ─────────────────────────────────────────
  // READ EASIFY OPTIONS FROM PAGE
  // ─────────────────────────────────────────
  function getEasifyOptions() {
    const options = { front: null, back: null };

    document.querySelectorAll('.po-checkboxOption-checkbox').forEach(input => {
      const fieldRoot = input.closest('.po-field-root');
      if (!fieldRoot) return;

      const fullText = fieldRoot.textContent.trim();
      const titleMatch = fullText.match(/^(.+?)(?:yes|no)/i);
      const title = titleMatch ? titleMatch[1].trim().toLowerCase() : fullText.toLowerCase();

      const labelEl = input.closest('label') || input.parentElement;
      const labelText = labelEl ? labelEl.textContent.trim() : "";
      const priceMatch = labelText.match(/Rs\.?\s*([\d,]+(?:\.\d+)?)/i);
      const price = priceMatch ? parseFloat(priceMatch[1].replace(/,/g, '')) : 0;

      if (title.includes("front")) {
        options.front = { input, price, label: `Front Print${price ? ` (+₹${Math.round(price)})` : ""}` };
      } else if (title.includes("back")) {
        options.back  = { input, price, label: `Back Print${price ? ` (+₹${Math.round(price)})` : ""}` };
      }
    });

    return options;
  }

  // ─────────────────────────────────────────
  // STYLES
  // ─────────────────────────────────────────
  const style = document.createElement("style");
  style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700&display=swap');

    .dp * { box-sizing: border-box; margin: 0; padding: 0; font-family: 'DM Sans', sans-serif; }

   .dp-overlay {
      position: fixed; inset: 0;
      background: rgba(0,0,0,0.55);
      backdrop-filter: blur(6px);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      animation: dpFade 0.2s ease;
      padding: 16px;
    }

    @keyframes dpFade { from{opacity:0} to{opacity:1} }

    .dp-modal {
      background: #fff;
      border-radius: 20px;
      display: flex;
      width: 860px;
      max-width: 98vw;
      max-height: 95vh;
      overflow: hidden;
      box-shadow: 0 32px 80px rgba(0,0,0,0.22);
      animation: dpUp 0.22s ease;
    }

    @keyframes dpUp { from{transform:translateY(16px);opacity:0} to{transform:translateY(0);opacity:1} }

    .dp-left {
      width: 360px;
      flex-shrink: 0;
      background: #f4f4f4;
      border-radius: 20px 0 0 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 28px 20px;
      gap: 14px;
      position: relative;
      overflow: hidden;
    }

    .dp-preview-tabs {
      display: flex;
      gap: 6px;
      position: absolute;
      top: 10%;
      left: 50%;
      transform: translateX(-50%);
    }

    .dp-ptab {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      color: #888;
      padding: 5px 14px;
      border-radius: 20px;
      background: #e8e8e8;
      border: none;
      cursor: pointer;
    }

    .dp-ptab.active {
      background: #fff;
      color: #111;
      box-shadow: 0 1px 4px rgba(0,0,0,0.1);
    }

    .dp-preview-img-wrap {
      width: 100%;
      aspect-ratio: 1;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    div#transformControls { display: none !important; }

    .dp-preview-img-wrap img.dp-base {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 10px;
      pointer-events: none;
      transition: all 0.3s ease-in-out;
      will-change: opacity, transform;
    }

    .dp-preview-img-wrap canvas { position: absolute; touch-action: none; }

    .dp-print-boundary {
      position: absolute;
      border: 1.5px dashed rgba(249, 115, 22, 0.55);
      border-radius: 4px;
      pointer-events: none;
    }

    .dp-resize-handle {
      display: none;
      position: absolute;
      width: 14px; height: 14px;
      background: #f97316;
      border: 2px solid #fff;
      border-radius: 50%;
      cursor: nwse-resize;
      box-shadow: 0 1px 4px rgba(0,0,0,0.3);
      z-index: 10;
    }

    .dp-resize-handle-x {
      display: none;
      position: absolute;
      width: 14px; height: 14px;
      background: #f97316;
      border: 2px solid #fff;
      border-radius: 50%;
      cursor: ew-resize;
      box-shadow: 0 1px 4px rgba(0,0,0,0.3);
      z-index: 10;
    }

    .dp-resize-handle-y {
      display: none;
      position: absolute;
      width: 14px; height: 14px;
      background: #f97316;
      border: 2px solid #fff;
      border-radius: 50%;
      cursor: ns-resize;
      box-shadow: 0 1px 4px rgba(0,0,0,0.3);
      z-index: 10;
    }

    .dp-no-img {
      width: 100%; aspect-ratio: 1;
      display: flex; flex-direction: column;
      align-items: center; justify-content: center;
      gap: 10px; color: #bbb; font-size: 13px;
    }

    .dp-preview-hint { font-size: 11px; color: #aaa; text-align: center; }

    .dp-right {
      flex: 1; overflow-y: auto;
      padding: 26px 24px;
      display: flex; flex-direction: column; gap: 16px;
    }

    .dp-right-header { display: flex; justify-content: space-between; }

    .dp-title { font-size: 16px; font-weight: 700; color: #111; }
    .dp-secure { text-align: center; }

    .dp-close {
      width: 28px; height: 28px;
      border: 1px solid #e5e5e5;
      background: #f5f5f5;
      border-radius: 50%; cursor: pointer;
    }

    .dp-easify-section { display: flex; flex-direction: column; gap: 8px; }

    .dp-easify-label {
      font-size: 12px; font-weight: 700;
      color: #555; text-transform: uppercase; letter-spacing: 0.04em;
    }

    .dp-easify-options { display: flex; flex-direction: column; gap: 6px; }

    .dp-easify-opt {
      display: flex; align-items: center; gap: 10px;
      padding: 10px 14px;
      border: 1.5px solid #e5e5e5;
      border-radius: 10px;
      cursor: pointer;
      transition: border-color 0.15s, background 0.15s;
      user-select: none;
    }

    .dp-easify-opt:hover { border-color: #f97316; background: #fff8f4; }

    .dp-easify-opt.dp-eopt-on {
      border-color: #f97316;
      background: #fff4ec;
    }

    .dp-eopt-box {
      width: 17px; height: 17px; flex-shrink: 0;
      border: 1.5px solid #ccc; border-radius: 4px;
      background: #fff;
      display: flex; align-items: center; justify-content: center;
      transition: background 0.15s, border-color 0.15s;
    }

    .dp-easify-opt.dp-eopt-on .dp-eopt-box {
      background: #f97316; border-color: #f97316;
    }

    .dp-eopt-name { flex: 1; font-size: 13px; font-weight: 600; color: #222; }

    .dp-eopt-price {
      font-size: 12px; font-weight: 700; color: #f97316;
      background: #fff4ec; padding: 2px 8px;
      border-radius: 20px;
    }

    .dp-easify-none {
      font-size: 12px; color: #aaa;
      padding: 8px 12px;
      background: #fafafa;
      border: 1px dashed #e0e0e0;
      border-radius: 8px;
    }

    .dp-chk { width: 17px; height: 17px; flex-shrink: 0; border: 1.5px solid #ccc; border-radius: 4px; background: #fff; display: flex; align-items: center; justify-content: center; transition: background 0.15s, border-color 0.15s; }
    .dp-chk.on { background: #f97316; border-color: #f97316; }
    .dp-same-txt { font-size: 12px; font-weight: 600; color: #333; }

    .dp-upload-zone {
      border: 1.5px dashed #d8d8d8; border-radius: 12px;
      padding: 16px; text-align: center; cursor: pointer;
      background: #fafafa; position: relative;
    }
    .dp-upload-zone:hover { border-color: #f97316; background: #f0f6ff; }
    .dp-upload-zone input[type="file"] { position: absolute; inset: 0; opacity: 0; cursor: pointer; }
    .dp-upload-main { font-size: 13px; font-weight: 600; }
    .dp-upload-sub { font-size: 11px; color: #aaa; }
    .dp-file-chip { display: none !important; margin-top: 6px; font-size: 12px; color: #f97316; }
    .dp-file-chip.show { display: flex !important; display:none !important; }

    .dp-side-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
    .dp-side-card { border: 1.5px solid #e5e5e5; border-radius: 10px; padding: 12px; text-align: center; cursor: pointer; }
    .dp-side-card.dp-active { border: 2px solid #f97316; background: #eff6ff; }
    .dp-side-card.dp-disabled { opacity: 0.3; pointer-events: none; }

    .dp-same-row { display: flex; align-items: center; gap: 10px; padding: 10px 12px; border: 1.5px solid #e5e5e5; border-radius: 10px; cursor: pointer; }
    .dp-same-row.on { border-color: #f97316; background: #eff6ff; }

    .dp-notes { width: 100%; border: 1.5px solid #e5e5e5; border-radius: 10px; padding: 10px 12px; font-size: 12px; min-height: 70px; }

    .dp-cta { width: 100%; padding: 13px; background: #f97316; color: #fff; border: none; border-radius: 10px; font-weight: 700; cursor: pointer; }
    .dp-cta:disabled { opacity: 0.6; cursor: not-allowed; }

    .dp-transform-controls { display: none; }
    .dp-tc-row { display: flex; align-items: center; gap: 10px; width: 100%; }
    .dp-tc-label { font-size: 11px; font-weight: 700; color: #555; width: 50px; flex-shrink: 0; text-transform: uppercase; }
    .dp-tc-row input[type="range"] { flex: 1; accent-color: #f97316; }
    .dp-tc-btn { width: 30px; height: 30px; border: 1.5px solid #e5e5e5; border-radius: 8px; background: #fafafa; cursor: pointer; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .dp-tc-btn:hover { border-color: #f97316; }

    @media (max-width: 768px) {
      .dp-overlay { padding: 10px; align-items: flex-start; }
      .dp-modal { flex-direction: column; width: 100%; max-width: 100%; max-height: 95vh; overflow-y: auto; border-radius: 14px; }
      .dp-left { width: 100%; min-height: 260px; padding: 16px; border-radius: 14px 14px 0 0; }
      .dp-preview-img-wrap { max-width: 240px; }
      .dp-right { padding: 16px; gap: 12px; }
      .dp-title { font-size: 14px; }
      .dp-side-grid { grid-template-columns: 1fr 1fr; }
      .dp-cta { font-size: 12px; }
    }

    @media (max-width: 480px) {
      .dp-upload-main { font-size: 12px; }
      .dp-upload-sub { font-size: 10px; }
    }
  `;
  document.head.appendChild(style);

  // ─── inline SVGs ───
  const uploadSVG = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>`;
  const cartSVG   = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>`;
  const lockSVG   = `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>`;
  const checkSVG  = `<svg width="10" height="10" viewBox="0 0 12 12" fill="none"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const imgSVG    = `<svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>`;
  const rotateLeftSVG  = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>`;
  const rotateRightSVG = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.13-9.36L23 10"/></svg>`;

  function teeIcon(active) {
    const c = active ? '#2563eb' : '#aaa';
    return `<svg width="32" height="32" viewBox="0 0 38 38" fill="none"><path d="M10 8 L6 14 L12 16 L12 30 L26 30 L26 16 L32 14 L28 8 C26 10 22 11 19 11 C16 11 12 10 10 8Z" fill="${c}" fill-opacity="0.15" stroke="${c}" stroke-width="1.6" stroke-linejoin="round"/></svg>`;
  }

  function newDesignState(img) {
    return { img, x: 0.5, y: 0.5, scale: 1, scaleX: 1, scaleY: 1, rotation: 0 };
  }

  function sanitizeImgUrl(url) {
    if (!url) return url;
    if (url.startsWith("//")) url = "https:" + url;
    url = url.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master|180x|360x|540x|720x|900x|1080x)\./i, '.');
    return url;
  }

  function proxyUrl(src) {
    if (!src) return src;
    const clean = src.replace(/^https?:\/\//, '');
    return "https://images.weserv.nl/?url=" + encodeURIComponent(clean);
  }

  // ─────────────────────────────────────────
  // TRIGGER EASIFY CHECKBOX
  // ─────────────────────────────────────────
  function triggerEasifyCheckbox(optObj, shouldBeChecked) {
    if (!optObj?.input) return;
    if (optObj.input.checked !== shouldBeChecked) {
      const label = optObj.input.closest('.po-optionItemLabel-optionItem') ||
                    optObj.input.closest('label') ||
                    optObj.input.parentElement;
      if (label) label.click();
      else optObj.input.click();
    }
  }

  // ─────────────────────────────────────────
  // OPEN POPUP
  // ─────────────────────────────────────────
  function openPopup(btn, mode) {
    if (document.querySelector(".dp-overlay")) return;

    const popupController = new AbortController();
    const { signal } = popupController;
    designs = { front: null, back: null };
    selectedSide     = mode === "back" ? "back" : "front";
    sameDesign       = false;
    lastUploadedSide = null;

    const frontImg = btn.getAttribute("data-front") || "";
    const rawBackImg = btn.getAttribute("data-back") || frontImg;

    // Agar specifically "Back" design karna chah rahe ho lekin back image hai hi nahi — yahin rok do
    if (mode === "back" && (!rawBackImg || rawBackImg === frontImg)) {
      alert("Sorry, this product doesn't have a back design option.");
      return;
    }

    // Will be confirmed async; start as unknown
    let backImg = rawBackImg;
    let hasRealBackImg = (rawBackImg && rawBackImg !== frontImg);

    // URL valid hai ya nahi dobara confirm karo (404 jaisa case catch karne ke liye)
    if (hasRealBackImg) {
      const probe = new Image();
      probe.onload  = () => { hasRealBackImg = true; };
      probe.onerror = () => { hasRealBackImg = false; applyBackAvailability(); };
      probe.src = rawBackImg;
    }

    const titleMap = { front: "Front Print", back: "Back Print", both: "Front & Back Print" };

    const showFront = mode !== "back";
    const showBack  = mode !== "front";

    let activeTab = showFront ? "front" : "back";

    const easifyOpts = getEasifyOptions();

    function updateEasifyPricing() {
      triggerEasifyCheckbox(easifyOpts.front, !!designs.front?.file);
      triggerEasifyCheckbox(easifyOpts.back,  !!designs.back?.file);
    }

    const popup = document.createElement("div");
    popup.className = "dp dp-overlay";
    popup.dataset.locked = "0";

    function buildSideCards() {
      const frontPrice = easifyOpts.front?.price ? `<div class="dp-eopt-price">+₹${Math.round(easifyOpts.front.price)}</div>` : "";
      const backPrice  = easifyOpts.back?.price  ? `<div class="dp-eopt-price">+₹${Math.round(easifyOpts.back.price)}</div>`  : "";
      const frontActive = mode !== "back";
      const backActive  = mode === "back";
      const frontDisabled = mode === "back"  ? 'style="opacity:0.35;pointer-events:none;"' : "";
      const backDisabled  = (mode === "front" || !hasRealBackImg) ? 'style="opacity:0.35;pointer-events:none;" title="No back image available"' : "";
      return `<div>
        <div class="dp-label">Select Print Side</div>
        <div class="dp-side-grid">
          <div class="dp-side-card ${frontActive ? 'dp-active' : ''}" id="cardFront" data-side="front" ${frontDisabled}>
            ${teeIcon(frontActive)}
            <div class="dp-side-card-lbl">Front</div>
            ${frontPrice}
          </div>
          <div class="dp-side-card ${backActive ? 'dp-active' : ''}" id="cardBack" data-side="back" ${backDisabled}>
            ${teeIcon(backActive)}
            <div class="dp-side-card-lbl">Back</div>
            ${backPrice}
          </div>
        </div>
      </div>`;
    }

    popup.innerHTML = `
      <div class="dp-modal">

        <!-- LEFT: live preview -->
        <div class="dp-left">
          ${(showFront && showBack) ? `
          <div class="dp-preview-tabs">
            <button class="dp-ptab active" data-tab="front">Front</button>
            <button class="dp-ptab"        data-tab="back">Back</button>
          </div>` : ""}

          <div class="dp-preview-img-wrap" id="previewWrap">
            ${(frontImg || backImg)
              ? `<img class="dp-base" id="previewBase" src="${showFront ? frontImg : backImg}" alt="preview">
                 <div class="dp-print-boundary" id="printBoundary"></div>
                 <canvas id="previewCanvas" width="600" height="600"></canvas>
                  <div class="dp-resize-handle" id="resizeHandle"></div>
                  <div class="dp-resize-handle-x" id="resizeHandleX" title="Drag to stretch left/right"></div>
                  <div class="dp-resize-handle-y" id="resizeHandleY" title="Drag to stretch top/bottom"></div>
                  <div id="dpNoBackMsg" style="
                    display: none;
                    position: absolute;
                    inset: 0;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    background: rgba(244,244,244,0.88);
                    border-radius: 10px;
                    text-align: center;
                    padding: 16px;
                    z-index: 5;
                  ">
                    <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#f97316" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                    <span style="font-size:13px;font-weight:700;color:#333;">No Back Image Available</span>
                    <span style="font-size:11px;color:#888;line-height:1.5;">This product does not have<br>a back side preview image.</span>
                  </div>`
              : `<div class="dp-no-img">${imgSVG}<span>No product image</span></div>`
            }
          </div>

          <p class="dp-preview-hint" id="previewHint">Upload a design, then drag / pinch / scroll to position</p>
        </div>

        <!-- RIGHT: controls -->
        <div class="dp-right">

          <div class="dp-right-header">
            <div class="dp-title">Customize: ${titleMap[mode]}</div>
            <button class="dp-close" id="dpClose">✕</button>
          </div>

          <!-- Upload -->
          <div>
            <div class="dp-label">Your Design File</div>
            <div class="dp-upload-zone">
              <input type="file" id="designFile" accept="image/*">
              <div class="dp-upload-icon">${uploadSVG}</div>
              <div class="dp-upload-main">Upload Your Design</div>
              <div class="dp-upload-sub">PNG, JPG, SVG — Max 25MB</div>
              <div class="dp-file-chip" id="fileChip">
                ${checkSVG.replace('stroke="#fff"','stroke="#2563eb"')}
                <span id="fileName"></span>
              </div>
            </div>
          </div>

            ${buildSideCards()}

          <!-- Same design toggle (only for "both" mode) -->
          ${mode === "both" ? `
          <div class="dp-same-row" id="sameRow">
            <div class="dp-chk" id="sameChk"></div>
            <span class="dp-same-txt">Same design on both sides</span>
          </div>` : ""}

          <!-- Position / Scale / Rotate controls -->
          <div class="dp-transform-controls" id="transformControls" style="display:none; flex-direction:column;">
            <div class="dp-tc-row">
              <span class="dp-tc-label">Size</span>
              <input type="range" id="scaleRange" min="0.2" max="1.25" step="0.01" value="1">
            </div>
            <div class="dp-tc-row">
              <span class="dp-tc-label">Width</span>
              <input type="range" id="stretchXRange" min="0.3" max="2" step="0.01" value="1">
            </div>
            <div class="dp-tc-row">
              <span class="dp-tc-label">Height</span>
              <input type="range" id="stretchYRange" min="0.3" max="2" step="0.01" value="1">
            </div>
            <div class="dp-tc-row">
              <span class="dp-tc-label">Rotate</span>
              <button class="dp-tc-btn" id="rotateLeft">${rotateLeftSVG}</button>
              <input type="range" id="rotateRange" min="-180" max="180" step="1" value="0">
              <button class="dp-tc-btn" id="rotateRight">${rotateRightSVG}</button>
            </div>
            <div class="dp-tc-row">
              <button class="dp-tc-btn" id="resetTransform" style="width:auto; padding:0 10px; font-size:11px; font-weight:700;">Reset Position</button>
            </div>
          </div>

          <!-- Notes -->
          <div>
            <div class="dp-label">Notes <span style="font-weight:400;color:#aaa;">(optional)</span></div>
            <div class="dp-notes-wrap">
              <textarea class="dp-notes" id="designNotes" maxlength="300"
                placeholder="e.g. Center the print, use white ink…"></textarea>
              <span class="dp-char" id="charCount">0/300</span>
            </div>
          </div>

          <!-- CTA -->
          <div>
            <button class="dp-cta" id="saveDesign">${cartSVG} Save &amp; Add to Cart</button>
            <div class="dp-secure" style="margin-top:8px;">${lockSVG} Secure &amp; Safe Checkout</div>
          </div>

        </div>
      </div>
    `;

    document.body.appendChild(popup);

    const canvas     = popup.querySelector("#previewCanvas");
    const handle     = popup.querySelector("#resizeHandle");
    const handleX    = popup.querySelector("#resizeHandleX");
    const handleY    = popup.querySelector("#resizeHandleY");
    const boundaryEl = popup.querySelector("#printBoundary");

    function applyBackAvailability() {
      const cardBack  = popup.querySelector("#cardBack");
      const sameRow   = popup.querySelector("#sameRow");
      const noBackMsg = popup.querySelector("#dpNoBackMsg");

      if (!hasRealBackImg) {
        if (cardBack) {
          cardBack.style.opacity = "0.35";
          cardBack.style.pointerEvents = "none";
          cardBack.title = "No back image available for this product";
        }
        if (sameRow) {
          sameRow.style.opacity = "0.35";
          sameRow.style.pointerEvents = "none";
        }
        if (activeTab === "back") {
          const base = popup.querySelector("#previewBase");
          if (base) base.style.opacity = "0.25";
          if (canvas) canvas.style.display = "none";
          if (boundaryEl) boundaryEl.style.display = "none";
          if (handle) handle.style.display = "none";
          if (handleX) handleX.style.display = "none";
          if (handleY) handleY.style.display = "none";
          if (noBackMsg) noBackMsg.style.display = "flex";
          const hint = popup.querySelector("#previewHint");
          if (hint) hint.style.display = "none";
          const uploadZone = popup.querySelector(".dp-upload-zone");
          const fileInput  = popup.querySelector("#designFile");
          if (uploadZone) { uploadZone.style.opacity = "0.4"; uploadZone.style.pointerEvents = "none"; }
          if (fileInput) fileInput.disabled = true;
        }
      } else {
        if (cardBack) {
          cardBack.style.opacity = "";
          cardBack.style.pointerEvents = "";
          cardBack.title = "";
        }
        if (sameRow) {
          sameRow.style.opacity = "";
          sameRow.style.pointerEvents = "";
        }
        const uploadZone = popup.querySelector(".dp-upload-zone");
        const fileInput  = popup.querySelector("#designFile");
        if (uploadZone) { uploadZone.style.opacity = ""; uploadZone.style.pointerEvents = ""; }
        if (fileInput) fileInput.disabled = false;
      }
    }

    applyBackAvailability();

    // ── PRINT ZONE ──
    const handleSlug = window.location.pathname.toLowerCase();

    // ── EXPORT FORMAT: PNG for all clothing products, JPEG only for accessories
    //    (mugs, totes, notebooks, posters, coasters, mousepads, pop-grips,
    //    phone cases, bottles) ──
    const accessoryKeywords = [
      "mug", "cup", "notebook", "poster", "tote", "phone-case",
      "sipper-bottle", "coaster", "mousepad", "pop-grip", "accessor"
    ];
    const isAccessoryProduct = accessoryKeywords.some(k => handleSlug.includes(k));
    const exportMime = isAccessoryProduct ? "image/jpeg" : "image/png";
    const exportExt  = isAccessoryProduct ? "jpg" : "png";
    const requiredLabel = isAccessoryProduct ? "JPG" : "PNG";

    // Restrict the file picker itself, and update the hint text, to match
    // the format required for this product type.
    const designFileInputEl = popup.querySelector("#designFile");
    const uploadSubEl        = popup.querySelector(".dp-upload-sub");
    if (designFileInputEl) designFileInputEl.setAttribute("accept", isAccessoryProduct ? "image/jpeg" : "image/png");
    if (uploadSubEl) uploadSubEl.textContent = `${requiredLabel} only — Max 25MB`;

    let zones = {
      front: { top: 22, left: 30, width: 38, height: 42 },
      back:  { top: 22, left: 30, width: 38, height: 42 }
    };
    if (handleSlug.includes("mug") || handleSlug.includes("cup")) {
      zones.front = { top: 25, left: 35, width: 40, height: 50 };
      zones.back  = { top: 25, left: 35, width: 40, height: 50 };
    }else if (handleSlug.includes("binded-pyd-notebook")) {
      zones.front = { top: 22, left: 26, width: 47, height: 50 };
      zones.back = { top: 20, left: 27, width: 47, height: 50 };
    }
     else if (handleSlug.includes("custom-hanging-poster-pyd")){
      zones.front = { top: 26, left: 24, width: 49, height: 49 };
    }
     else if (handleSlug.includes("kids-half-sleeve-round-neck-t-shirt-1")){
      zones.front = { top: 34, left: 35, width: 28, height: 30 };
      zones.back  = { top: 34, left: 35, width: 28, height: 30 };
    }
    else if (handleSlug.includes("kid") || handleSlug.includes("kids") || handleSlug.includes("youth") || handleSlug.includes("children")) {
      zones.front = { top: 28, left: 32, width: 34, height: 36 };
      zones.back  = { top: 26, left: 30, width: 38, height: 42 };
    } else if (handleSlug.includes("mens-pyd-hoodies") || handleSlug.includes("mens-hoodies-plain")) {
      zones.front = { top: 34, left: 33, width: 32, height: 32 };
      zones.back  = { top: 34, left: 31, width: 37, height: 37 };
    } else if (handleSlug.includes("tote") || handleSlug.includes("tote-bag") || handleSlug.includes("tote_bag")) {
      zones.front = { top: 40, left: 28, width: 44, height: 52 };
      zones.back  = { top: 40, left: 28, width: 44, height: 52 };
    } else if (handleSlug.includes("glass-phone-cases")) {
      zones.front = { top: 30, left: 32, width: 34, height: 42 };
      zones.back  = { top: 30, left: 32, width: 34, height: 42 };
    } else if (handleSlug.includes("aluminium-sipper-bottle-pyd")) {
      zones.front = { top: 36, left: 38, width: 26, height: 50 };
      zones.back  = { top: 36, left: 40, width: 24, height: 50 };
    } else if (handleSlug.includes("posters")) {
      zones.front = { top: 18, left: 27, width: 46, height: 56 };
      zones.back  = { top: 18, left: 27, width: 46, height: 56 };
    } else if (handleSlug.includes("coasters")) {
      zones.front = { top: 24, left: 28, width: 44, height: 50 };
      zones.back  = { top: 24, left: 28, width: 44, height: 50 };
    } else if (handleSlug.includes("notebooks")) {
      zones.front = { top: 18, left: 27, width: 49, height: 56 };
      zones.back  = { top: 18, left: 27, width: 49, height: 56 };
    } else if (handleSlug.includes("sweatshirt")) {
      zones.front = { top: 26, left: 30, width: 38, height: 38 };
      zones.back  = { top: 26, left: 30, width: 37, height: 37 };
    } else if (handleSlug.includes("crop-tops")) {
      zones.front = { top: 32, left: 30, width: 38, height: 36 };
      zones.back  = { top: 31, left: 30, width: 38, height: 38 };
    } else if (handleSlug.includes("crop-tank-top")) {
      zones.front = { top: 32, left: 26, width: 45, height: 44 };
      zones.back  = { top: 32, left: 26, width: 46, height: 46 };
    } else if (handleSlug.includes("toddler-half-sleeve-round-neck-t-shirt")) {
      zones.front = { top: 32, left: 32, width: 34, height: 32 };
      zones.back  = { top: 32, left: 32, width: 34, height: 32 };
    } else if (handleSlug.includes("men-s-pyd-shorts") || handleSlug.includes("men-s-shorts")) {
      zones.front = { top: 46, left: 16, width: 31, height: 30 };
      zones.back  = { top: 46, left: 52, width: 31, height: 30 };
    } else if (handleSlug.includes("men-s-pyd-joggers") || handleSlug.includes("men-s-joggers")) {
      zones.front = { top: 26, left: 31, width: 15, height: 16 };
      zones.back  = { top: 26, left: 52, width: 15, height: 16 };
    } else if (handleSlug.includes("men-s-pyd-bomber-jacket") || handleSlug.includes("men-s-bomber-jacket")) {
      zones.front = { top: 30, left: 55, width: 15, height: 16 };
      zones.back  = { top: 22, left: 28, width: 43, height: 44 };
    } else if (handleSlug.includes("mens-pyd-classic-polo-t-shirt") || handleSlug.includes("mens-classic-polo-t-shirt-plain")) {
      zones.front = { top: 27, left: 55, width: 15, height: 16 };
      zones.back  = { top: 20, left: 28, width: 42, height: 46 };
    } else if (handleSlug.includes("men-s-pyd-half-sleeve-v-neck-t-shirt")) {
      zones.front = { top: 28, left: 28, width: 42, height: 42 };
      zones.back  = { top: 20, left: 28, width: 42, height: 42 };
    } else if (handleSlug.includes("womens-crop-hoodies")) {
      zones.front = { top: 34, left: 33, width: 32, height: 32 };
      zones.back  = { top: 34, left: 31, width: 37, height: 32 };
    } else if (handleSlug.includes("mousepads-pyd")) {
      zones.front = { top: 18, left: 18, width: 62, height: 63 };
    } else if (handleSlug.includes("pop-grips-pyd")) {
      zones.front = { top: 28, left: 26, width: 46, height: 44 };
    } else if (handleSlug.includes("mens-pyd-oversized-hoodies") || handleSlug.includes("mens-oversized-hoodies")) {
      zones.front = { top: 34, left: 32, width: 33, height: 32 };
       zones.back = { top: 34, left: 32, width: 36, height: 40 };
    } 

    const SHRINK_W = 0.96, SHRINK_H = 0.9, OFFSET_X = 1.1, OFFSET_Y = 0;

    // Max scale so the design can never visually stretch past the dashed print-boundary box.
    // baseSize (drawing size at scale=1) is 80% of the canvas box, so 1/0.8 = 1.25 fills the box exactly.
    // NOTE: this is only the absolute ceiling for an UNROTATED image centered in the box.
    // The real, always-enforced limit is computed dynamically in clampDesignToBox() below,
    // which accounts for rotation and position so the design can never spill outside the box.
    const MAX_DESIGN_SCALE = 1.25;

    function applyZone(side) {
      const zone = zones[side] || zones.front;
      const shrunkZone = {
        width:  zone.width  * SHRINK_W,
        height: zone.height * SHRINK_H,
        left:   zone.left + (zone.width  - zone.width  * SHRINK_W) / 2 + OFFSET_X,
        top:    zone.top  + (zone.height - zone.height * SHRINK_H) / 2 + OFFSET_Y
      };

      if (canvas) {
        canvas.style.position = "absolute";
        canvas.style.top    = shrunkZone.top + "%";
        canvas.style.left   = shrunkZone.left + "%";
        canvas.style.width  = shrunkZone.width + "%";
        canvas.style.height = shrunkZone.height + "%";
        canvas.style.cursor = "grab";
        canvas._zone = shrunkZone;
      }

      if (boundaryEl) {
        boundaryEl.style.top    = shrunkZone.top + "%";
        boundaryEl.style.left   = shrunkZone.left + "%";
        boundaryEl.style.width  = shrunkZone.width + "%";
        boundaryEl.style.height = shrunkZone.height + "%";
      }
    }

    // Initial zone apply
    applyZone(activeTab);

    // ── side card click ──
    popup.querySelectorAll(".dp-side-card").forEach(card => {
      card.addEventListener("click", function () {
        if (sameDesign) return;
        selectedSide = this.dataset.side;

        popup.querySelectorAll(".dp-side-card").forEach(c => c.classList.remove("dp-active"));
        this.classList.add("dp-active");

        const matchTab = popup.querySelector(`.dp-ptab[data-tab="${selectedSide}"]`);
        if (matchTab) matchTab.click();

        popup.querySelector("#designFile").value = "";
      });
    });

    // ── preview tab switching ──
    // ── preview tab switching ──
popup.querySelectorAll(".dp-ptab").forEach(tab => {
  tab.addEventListener("click", function () {
    popup.querySelectorAll(".dp-ptab").forEach(t => t.classList.remove("active"));
    this.classList.add("active");
    activeTab = this.dataset.tab;
    const base = popup.querySelector("#previewBase");
    const noBackMsg = popup.querySelector("#dpNoBackMsg");
    if (!base) return;

    // ── Check if a real back image exists ──

    if (activeTab === "back" && !hasRealBackImg) {
      applyBackAvailability();
      return; // Don't switch, stay visual-only
    }

    // Usable side pe switch ho rahe ho — upload wapas enable karo
    const uploadZoneEl = popup.querySelector(".dp-upload-zone");
    const fileInputEl  = popup.querySelector("#designFile");
    if (uploadZoneEl) { uploadZoneEl.style.opacity = ""; uploadZoneEl.style.pointerEvents = ""; }
    if (fileInputEl) fileInputEl.disabled = false;

    // Normal tab switch
    if (noBackMsg) noBackMsg.style.display = "none";
    base.style.opacity = "1";
    if (canvas) canvas.style.display = "";
    if (boundaryEl) boundaryEl.style.display = "";

    if (activeTab === "front") base.src = frontImg;
    else base.src = backImg;

    applyZone(activeTab);
    syncControlsToDesign(popup, activeTab);
    drawCanvas(canvas, designs[activeTab], handle, handleX, handleY);
  });
});

    // ── same design toggle ──
    const sameRow = popup.querySelector("#sameRow");
    if (sameRow) {
      sameRow.addEventListener("click", function () {
        if (!hasRealBackImg) return;
        sameDesign = !sameDesign;
        const chk = popup.querySelector("#sameChk");
        const row = popup.querySelector("#sameRow");

        if (sameDesign) {
          // ── TURNING ON: mirror whichever side has a design ──
          selectedSide = "both";
          chk.classList.add("on"); chk.innerHTML = checkSVG; row.classList.add("on");
          if (lastUploadedSide === "front" && designs.front) designs.back  = { ...designs.front };
          if (lastUploadedSide === "back"  && designs.back)  designs.front = { ...designs.back  };
          updateEasifyPricing();
          syncControlsToDesign(popup, activeTab);
          drawCanvas(canvas, designs[activeTab], handle, handleX, handleY);
        } else {
          // ──  TURNING OFF: clear both sides & reset file input ──
          chk.classList.remove("on"); chk.innerHTML = ""; row.classList.remove("on");
          selectedSide     = "front";
          lastUploadedSide = null;
          designs.front    = null;
          designs.back     = null;
          // Reset file input so user can re-upload
          const fileInput = popup.querySelector("#designFile");
          if (fileInput) fileInput.value = "";
          const fileChip = popup.querySelector("#fileChip");
          if (fileChip) fileChip.classList.remove("show");
          popup.querySelector("#transformControls").style.display = "none";
          popup.querySelector("#previewHint").style.display = "";
          updateEasifyPricing();
          syncControlsToDesign(popup, activeTab);
          drawCanvas(canvas, designs[activeTab], handle, handleX, handleY);
        }
      });
    }

    // ── char counter ──
    popup.querySelector("#designNotes").addEventListener("input", function () {
      popup.querySelector("#charCount").textContent = this.value.length + "/300";
    });

    // ── file upload ──
    popup.querySelector("#designFile").addEventListener("change", function (e) {
      const file = e.target.files[0];
      if (!file) return;

      // Enforce the required format for this product type — reject anything
      // else instead of silently accepting/converting it, so the customer
      // knows immediately what went wrong.
      const isPngFile  = file.type === "image/png";
      const isJpegFile = file.type === "image/jpeg" || file.type === "image/jpg";
      const typeOk = isAccessoryProduct ? isJpegFile : isPngFile;

      if (!typeOk) {
        alert(`Please upload a ${requiredLabel} file for this product.`);
        this.value = "";
        return;
      }

      const chip = popup.querySelector("#fileChip");
      popup.querySelector("#fileName").textContent = file.name;
      chip.classList.add("show");

      const reader = new FileReader();
      reader.onload = evt => {
        const img = new Image();
        img.onload = () => {
          const state = newDesignState(img);
          state.file = file;

          // ── FIX BUG 1: sameDesign ON hai to dono sides pe set karo,
          //    warna sirf activeTab pe ──
          if (sameDesign) {
            designs.front    = { ...state, file };
            designs.back     = { ...state, file };
            lastUploadedSide = "both";
          } else if (activeTab === "front") {
            designs.front    = state;
            lastUploadedSide = "front";
          } else {
            designs.back     = { ...state, file };
            lastUploadedSide = "back";
          }

          updateEasifyPricing();

          popup.querySelector("#transformControls").style.display = "flex";
          popup.querySelector("#previewHint").style.display = "none";
          syncControlsToDesign(popup, activeTab);
          drawCanvas(canvas, designs[activeTab], handle, handleX, handleY);
        };
        img.src = evt.target.result;
      };
      reader.readAsDataURL(file);
    });

    // ── transform controls ──
    const scaleRange     = popup.querySelector("#scaleRange");
    const stretchXRange  = popup.querySelector("#stretchXRange");
    const stretchYRange  = popup.querySelector("#stretchYRange");
    const rotateRange    = popup.querySelector("#rotateRange");
    const rotateLeftBtn  = popup.querySelector("#rotateLeft");
    const rotateRightBtn = popup.querySelector("#rotateRight");
    const resetBtn       = popup.querySelector("#resetTransform");

    scaleRange.addEventListener("input", function () {
      const d = designs[activeTab]; if (!d) return;
      // User-requested scale — drawCanvas() will clamp this in place so it can
      // never exceed the box (accounting for current rotation/position).
      d.scale = parseFloat(this.value);
      if (sameDesign) syncBothSides(d);
      drawCanvas(canvas, designs[activeTab], handle, handleX, handleY);
      // Reflect the actual (possibly clamped) value back on the slider.
      this.value = designs[activeTab].scale;
    });

    stretchXRange.addEventListener("input", function () {
      const d = designs[activeTab]; if (!d) return;
      d.scaleX = parseFloat(this.value);
      if (sameDesign) syncBothSides(d);
      drawCanvas(canvas, designs[activeTab], handle, handleX, handleY);
      this.value = designs[activeTab].scaleX;
    });

    stretchYRange.addEventListener("input", function () {
      const d = designs[activeTab]; if (!d) return;
      d.scaleY = parseFloat(this.value);
      if (sameDesign) syncBothSides(d);
      drawCanvas(canvas, designs[activeTab], handle, handleX, handleY);
      this.value = designs[activeTab].scaleY;
    });

    rotateRange.addEventListener("input", function () {
      const d = designs[activeTab]; if (!d) return;
      d.rotation = parseFloat(this.value);
      if (sameDesign) syncBothSides(d);
      drawCanvas(canvas, designs[activeTab], handle, handleX, handleY);
      // Rotating can shrink the max allowed scale — keep the size slider in sync.
      scaleRange.value = designs[activeTab].scale;
      stretchXRange.value = designs[activeTab].scaleX;
      stretchYRange.value = designs[activeTab].scaleY;
    });

    rotateLeftBtn.addEventListener("click", () => {
      const d = designs[activeTab]; if (!d) return;
      d.rotation -= 15;
      if (d.rotation < -180) d.rotation += 360;
      rotateRange.value = d.rotation;
      if (sameDesign) syncBothSides(d);
      drawCanvas(canvas, designs[activeTab], handle, handleX, handleY);
      scaleRange.value = designs[activeTab].scale;
      stretchXRange.value = designs[activeTab].scaleX;
      stretchYRange.value = designs[activeTab].scaleY;
    });

    rotateRightBtn.addEventListener("click", () => {
      const d = designs[activeTab]; if (!d) return;
      d.rotation += 15;
      if (d.rotation > 180) d.rotation -= 360;
      rotateRange.value = d.rotation;
      if (sameDesign) syncBothSides(d);
      drawCanvas(canvas, designs[activeTab], handle, handleX, handleY);
      scaleRange.value = designs[activeTab].scale;
      stretchXRange.value = designs[activeTab].scaleX;
      stretchYRange.value = designs[activeTab].scaleY;
    });

    resetBtn.addEventListener("click", () => {
      const d = designs[activeTab]; if (!d) return;
      d.x = 0.5; d.y = 0.5; d.scale = 1; d.scaleX = 1; d.scaleY = 1; d.rotation = 0;
      scaleRange.value = 1; stretchXRange.value = 1; stretchYRange.value = 1; rotateRange.value = 0;
      if (sameDesign) syncBothSides(d);
      drawCanvas(canvas, designs[activeTab], handle, handleX, handleY);
    });

    function syncBothSides(d) {
      designs.front = { ...d };
      designs.back  = { ...d };
    }

    setupCanvasInteractions(canvas, popup, () => activeTab, () => sameDesign,
      () => { drawCanvas(canvas, designs[activeTab], handle, handleX, handleY); },
      (newScale) => { scaleRange.value = newScale; },
      (newRot)   => { rotateRange.value = newRot; },
      designsRef,
      signal,
      MAX_DESIGN_SCALE
    );

    setupResizeHandle(handle, canvas, popup, () => activeTab, () => sameDesign,
      () => { drawCanvas(canvas, designs[activeTab], handle, handleX, handleY); },
      (newScale) => { scaleRange.value = newScale; },
      designsRef,
      signal,
      MAX_DESIGN_SCALE
    );

    setupStretchHandle(handleX, canvas, popup, () => activeTab, () => sameDesign,
      () => { drawCanvas(canvas, designs[activeTab], handle, handleX, handleY); },
      (newVal) => { stretchXRange.value = newVal; },
      designsRef,
      signal,
      "x"
    );

    setupStretchHandle(handleY, canvas, popup, () => activeTab, () => sameDesign,
      () => { drawCanvas(canvas, designs[activeTab], handle, handleX, handleY); },
      (newVal) => { stretchYRange.value = newVal; },
      designsRef,
      signal,
      "y"
    );

    function designsRef() { return designs; }

    function closePopup() {
      popupController.abort();
      popup.remove();
    }
    popup.querySelector("#dpClose").addEventListener("click", closePopup);
    popup.addEventListener("click", e => { if (e.target === popup) closePopup(); });

    popup.querySelector("#saveDesign").addEventListener("click", () =>
      handleSave(popup, mode, canvas, activeTab, frontImg, backImg, easifyOpts, zones, SHRINK_W, SHRINK_H, OFFSET_X, OFFSET_Y, exportMime, exportExt)
    );

    drawCanvas(canvas, designs[activeTab], handle, handleX, handleY);
  }

  // ─────────────────────────────────────────
  // SYNC SLIDER UI TO CURRENT DESIGN STATE
  // ─────────────────────────────────────────
  function syncControlsToDesign(popup, activeTab) {
    const d = designs[activeTab];
    const scaleRange        = popup.querySelector("#scaleRange");
    const stretchXRange     = popup.querySelector("#stretchXRange");
    const stretchYRange     = popup.querySelector("#stretchYRange");
    const rotateRange       = popup.querySelector("#rotateRange");
    const transformControls = popup.querySelector("#transformControls");
    if (!d) { transformControls.style.display = "none"; return; }
    transformControls.style.display = "flex";
    scaleRange.value  = d.scale;
    stretchXRange.value = d.scaleX != null ? d.scaleX : 1;
    stretchYRange.value = d.scaleY != null ? d.scaleY : 1;
    rotateRange.value = d.rotation;
  }

  // ─────────────────────────────────────────
  // BOX-BOUNDARY CLAMPING
  // ─────────────────────────────────────────
  function getDesignDrawSize(design, canvasSize) {
    const baseSize = canvasSize * 0.8;
    const aspect = design.img.width / design.img.height;
    let w, h;
    if (aspect >= 1) { w = baseSize * design.scale; h = w / aspect; }
    else             { h = baseSize * design.scale; w = h * aspect; }
    const sx = design.scaleX != null ? design.scaleX : 1;
    const sy = design.scaleY != null ? design.scaleY : 1;
    return { w: w * sx, h: h * sy };
  }

  function getRotatedBBox(w, h, rotationDeg) {
    const rad = rotationDeg * Math.PI / 180;
    const bboxW = Math.abs(w * Math.cos(rad)) + Math.abs(h * Math.sin(rad));
    const bboxH = Math.abs(w * Math.sin(rad)) + Math.abs(h * Math.cos(rad));
    return { bboxW, bboxH };
  }

  function getMaxScaleForBox(design, canvasSize) {
    const DRAG_MARGIN = 0.93;
    const baseSize = canvasSize * 0.8;
    const aspect = design.img.width / design.img.height;
    let w1, h1;
    if (aspect >= 1) { w1 = baseSize; h1 = w1 / aspect; } else { h1 = baseSize; w1 = h1 * aspect; }
    const { bboxW, bboxH } = getRotatedBBox(w1, h1, design.rotation);
    const limit = Math.min((canvasSize * DRAG_MARGIN) / bboxW, (canvasSize * DRAG_MARGIN) / bboxH);
    return Math.max(0.2, Math.min(1.25, limit));
  }

  function getMaxStretchForBox(design, canvasSize, axis) {
    const DRAG_MARGIN = 0.93;
    const baseSize = canvasSize * 0.8;
    const aspect = design.img.width / design.img.height;
    let w1, h1;
    if (aspect >= 1) { w1 = baseSize * design.scale; h1 = w1 / aspect; }
    else             { h1 = baseSize * design.scale; w1 = h1 * aspect; }
    const sx = design.scaleX != null ? design.scaleX : 1;
    const sy = design.scaleY != null ? design.scaleY : 1;
    const rad = design.rotation * Math.PI / 180;
    const cos = Math.abs(Math.cos(rad)), sin = Math.abs(Math.sin(rad));
    const limitBox = canvasSize * DRAG_MARGIN;

    if (axis === "x") {
      const wc = w1 * cos, ws = w1 * sin;
      const fixedW = h1 * sy * sin;
      const fixedH = h1 * sy * cos;
      const maxFromW = wc > 0 ? (limitBox - fixedW) / wc : Infinity;
      const maxFromH = ws > 0 ? (limitBox - fixedH) / ws : Infinity;
      const limit = Math.min(maxFromW, maxFromH);
      return Math.max(0.3, Math.min(2, limit));
    } else {
      const hs = h1 * sin, hc = h1 * cos;
      const fixedW = w1 * sx * cos;
      const fixedH = w1 * sx * sin;
      const maxFromW = hs > 0 ? (limitBox - fixedW) / hs : Infinity;
      const maxFromH = hc > 0 ? (limitBox - fixedH) / hc : Infinity;
      const limit = Math.min(maxFromW, maxFromH);
      return Math.max(0.3, Math.min(2, limit));
    }
  }

  function clampDesignToBox(design, canvasSize) {
    if (!design || !design.img) return;

    if (design.scaleX == null) design.scaleX = 1;
    if (design.scaleY == null) design.scaleY = 1;

    const maxScale = getMaxScaleForBox(design, canvasSize);
    design.scale = Math.max(0.2, Math.min(design.scale, maxScale));

    const maxStretchX = getMaxStretchForBox(design, canvasSize, "x");
    design.scaleX = Math.max(0.3, Math.min(design.scaleX, maxStretchX));
    const maxStretchY = getMaxStretchForBox(design, canvasSize, "y");
    design.scaleY = Math.max(0.3, Math.min(design.scaleY, maxStretchY));

    const { w, h } = getDesignDrawSize(design, canvasSize);
    const { bboxW, bboxH } = getRotatedBBox(w, h, design.rotation);
    const halfW = bboxW / 2, halfH = bboxH / 2;

    let minX = halfW / canvasSize, maxX = 1 - halfW / canvasSize;
    let minY = halfH / canvasSize, maxY = 1 - halfH / canvasSize;
    if (minX > maxX) { minX = maxX = 0.5; }
    if (minY > maxY) { minY = maxY = 0.5; }

    design.x = Math.min(maxX, Math.max(minX, design.x));
    design.y = Math.min(maxY, Math.max(minY, design.y));
  }

  // ─────────────────────────────────────────
  // CANVAS DRAW
  // ─────────────────────────────────────────
  function drawCanvas(canvas, design, handle, handleX, handleY) {
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!design || !design.img) {
      if (handle) handle.style.display = "none";
      if (handleX) handleX.style.display = "none";
      if (handleY) handleY.style.display = "none";
      return;
    }

    clampDesignToBox(design, canvas.width);

    const { img, x, y, scale, rotation } = design;
    const sx = design.scaleX != null ? design.scaleX : 1;
    const sy = design.scaleY != null ? design.scaleY : 1;
    const baseSize = canvas.width * 0.8;
    const aspect   = img.width / img.height;
    let w, h;
    if (aspect >= 1) { w = baseSize * scale; h = w / aspect; }
    else             { h = baseSize * scale; w = h * aspect; }
    w *= sx;
    h *= sy;

   const cx = x * canvas.width;
   const cy = y * canvas.height;

   ctx.save();
   ctx.beginPath();
   ctx.rect(0, 0, canvas.width, canvas.height);
   ctx.clip();
   ctx.translate(cx, cy);
   ctx.rotate(rotation * Math.PI / 180);
   ctx.drawImage(img, -w / 2, -h / 2, w, h);
   ctx.restore();

    const canvasRect = canvas.getBoundingClientRect();
    const wrapRect   = canvas.parentElement.getBoundingClientRect();
    const scaleXpx = canvasRect.width  / canvas.width;
    const scaleYpx = canvasRect.height / canvas.height;
    const rad = rotation * Math.PI / 180;
    const cosR = Math.cos(rad), sinR = Math.sin(rad);

    if (handle) {
      handle.style.display = "block";
      const localX = w / 2, localY = h / 2;
      const rx = cx + (localX * cosR - localY * sinR);
      const ry = cy + (localX * sinR + localY * cosR);
      const left = (canvasRect.left - wrapRect.left) + rx * scaleXpx;
      const top  = (canvasRect.top  - wrapRect.top)  + ry * scaleYpx;
      handle.style.left = (left - 8) + "px";
      handle.style.top  = (top  - 8) + "px";
    }

    if (handleX) {
      handleX.style.display = "block";
      const localX = w / 2, localY = 0;
      const rx = cx + (localX * cosR - localY * sinR);
      const ry = cy + (localX * sinR + localY * cosR);
      const left = (canvasRect.left - wrapRect.left) + rx * scaleXpx;
      const top  = (canvasRect.top  - wrapRect.top)  + ry * scaleYpx;
      handleX.style.left = (left - 7) + "px";
      handleX.style.top  = (top  - 7) + "px";
    }

    if (handleY) {
      handleY.style.display = "block";
      const localX = 0, localY = h / 2;
      const rx = cx + (localX * cosR - localY * sinR);
      const ry = cy + (localX * sinR + localY * cosR);
      const left = (canvasRect.left - wrapRect.left) + rx * scaleXpx;
      const top  = (canvasRect.top  - wrapRect.top)  + ry * scaleYpx;
      handleY.style.left = (left - 7) + "px";
      handleY.style.top  = (top  - 7) + "px";
    }
  }

  // ─────────────────────────────────────────
  // CANVAS INTERACTIONS
  // ─────────────────────────────────────────
  function setupCanvasInteractions(canvas, popup, getActiveTab, getSameDesign, redraw, setScaleUI, setRotUI, getDesigns, signal, maxScale) {
    if (!canvas) return;
    maxScale = maxScale || 1.25;
    let dragging = false, lastX = 0, lastY = 0;
    let pinchStartDist = 0, pinchStartScale = 1, pinchStartAngle = 0, pinchStartRotation = 0;

    function getDesign() { return getDesigns()[getActiveTab()]; }
    function syncIfSame(d) {
      if (getSameDesign()) { const ds = getDesigns(); ds.front = { ...d }; ds.back = { ...d }; }
    }

    canvas.addEventListener("mousedown", e => {
      if (!getDesign()) return;
      dragging = true; lastX = e.clientX; lastY = e.clientY;
      canvas.style.cursor = "grabbing";
    }, { signal });

    window.addEventListener("mousemove", e => {
      if (!dragging) return;
      const d = getDesign(); if (!d) return;
      const rect = canvas.getBoundingClientRect();
      d.x = Math.min(1, Math.max(0, d.x + (e.clientX - lastX) / rect.width));
      d.y = Math.min(1, Math.max(0, d.y + (e.clientY - lastY) / rect.height));
      lastX = e.clientX; lastY = e.clientY;
      syncIfSame(d); redraw();
    }, { signal });

    window.addEventListener("mouseup", () => { if (dragging) canvas.style.cursor = "grab"; dragging = false; }, { signal });

    canvas.addEventListener("wheel", e => {
      const d = getDesign(); if (!d) return;
      e.preventDefault();
      d.scale = Math.min(maxScale, Math.max(0.2, d.scale + (e.deltaY > 0 ? -0.05 : 0.05)));
      syncIfSame(d); redraw();
      setScaleUI(d.scale);
    }, { passive: false, signal });

    canvas.addEventListener("touchstart", e => {
      const d = getDesign(); if (!d) return;
      if (e.touches.length === 1) {
        dragging = true; lastX = e.touches[0].clientX; lastY = e.touches[0].clientY;
      } else if (e.touches.length === 2) {
        dragging = false;
        const t1 = e.touches[0], t2 = e.touches[1];
        pinchStartDist     = Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
        pinchStartAngle    = Math.atan2(t2.clientY - t1.clientY, t2.clientX - t1.clientX) * 180 / Math.PI;
        pinchStartScale    = d.scale;
        pinchStartRotation = d.rotation;
      }
    }, { passive: false, signal });

    canvas.addEventListener("touchmove", e => {
      const d = getDesign(); if (!d) return;
      e.preventDefault();
      if (e.touches.length === 1 && dragging) {
        const rect = canvas.getBoundingClientRect();
        d.x = Math.min(1, Math.max(0, d.x + (e.touches[0].clientX - lastX) / rect.width));
        d.y = Math.min(1, Math.max(0, d.y + (e.touches[0].clientY - lastY) / rect.height));
        lastX = e.touches[0].clientX; lastY = e.touches[0].clientY;
        syncIfSame(d); redraw();
      } else if (e.touches.length === 2) {
        const t1 = e.touches[0], t2 = e.touches[1];
        const dist  = Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
        const angle = Math.atan2(t2.clientY - t1.clientY, t2.clientX - t1.clientX) * 180 / Math.PI;
        d.scale = Math.min(maxScale, Math.max(0.2, pinchStartScale * (dist / pinchStartDist)));
        let rot = pinchStartRotation + (angle - pinchStartAngle);
        if (rot > 180) rot -= 360; if (rot < -180) rot += 360;
        d.rotation = rot;
        syncIfSame(d); redraw();
        setScaleUI(d.scale); setRotUI(d.rotation);
      }
    }, { passive: false, signal });

    canvas.addEventListener("touchend", () => { dragging = false; }, { signal });
  }

  // ─────────────────────────────────────────
  // RESIZE HANDLE (uniform, corner)
  // ─────────────────────────────────────────
  function setupResizeHandle(handle, canvas, popup, getActiveTab, getSameDesign, redraw, setScaleUI, getDesigns, signal, maxScale) {
    if (!handle) return;
    maxScale = maxScale || 1.25;
    let resizing = false;
    function getDesign() { return getDesigns()[getActiveTab()]; }
    function syncIfSame(d) {
      if (getSameDesign()) { const ds = getDesigns(); ds.front = { ...d }; ds.back = { ...d }; }
    }

       function doResize(clientX, clientY) {
         const d = getDesign(); if (!d || !resizing) return;
         const canvasRect = canvas.getBoundingClientRect();
         const centerX = canvasRect.left + d.x * canvasRect.width;
         const centerY = canvasRect.top  + d.y * canvasRect.height;
         const dist = Math.hypot(clientX - centerX, clientY - centerY);
         const baseSize = canvas.width * 0.8;
         const scaleRatio = canvasRect.width / canvas.width;
         const aspect = d.img.width / d.img.height;
         const refSize = aspect >= 1
           ? (baseSize * scaleRatio) / 2
           : (baseSize * aspect * scaleRatio) / 2;
         d.scale = Math.min(maxScale, Math.max(0.2, dist / refSize));
         syncIfSame(d); redraw();
         setScaleUI(d.scale);
       }

    handle.addEventListener("mousedown", e => { e.stopPropagation(); e.preventDefault(); if (!getDesign()) return; resizing = true; },{ signal });
    window.addEventListener("mousemove", e => { if (resizing) doResize(e.clientX, e.clientY); },{ signal });
    window.addEventListener("mouseup", () => { resizing = false; },{ signal });
    handle.addEventListener("touchstart", e => { e.stopPropagation(); e.preventDefault(); if (!getDesign()) return; resizing = true; }, { passive: false, signal });
    window.addEventListener("touchmove", e => { if (!resizing) return; doResize(e.touches[0].clientX, e.touches[0].clientY); }, { signal });
    window.addEventListener("touchend", () => { resizing = false; },{ signal });
  }

  // ─────────────────────────────────────────
  // STRETCH HANDLE
  // ─────────────────────────────────────────
  function setupStretchHandle(handle, canvas, popup, getActiveTab, getSameDesign, redraw, setStretchUI, getDesigns, signal, axis) {
    if (!handle) return;
    let resizing = false;
    function getDesign() { return getDesigns()[getActiveTab()]; }
    function syncIfSame(d) {
      if (getSameDesign()) { const ds = getDesigns(); ds.front = { ...d }; ds.back = { ...d }; }
    }

    function doResize(clientX, clientY) {
      const d = getDesign(); if (!d || !resizing) return;
      const canvasRect = canvas.getBoundingClientRect();
      const scaleRatio = canvasRect.width / canvas.width;
      const centerX = canvasRect.left + d.x * canvasRect.width;
      const centerY = canvasRect.top  + d.y * canvasRect.height;

      const rad = (d.rotation || 0) * Math.PI / 180;
      const dx = clientX - centerX, dy = clientY - centerY;
      const localX =  dx * Math.cos(rad) + dy * Math.sin(rad);
      const localY = -dx * Math.sin(rad) + dy * Math.cos(rad);

      const baseSize = canvas.width * 0.8;
      const aspect = d.img.width / d.img.height;
      let w1, h1;
      if (aspect >= 1) { w1 = baseSize * d.scale; h1 = w1 / aspect; }
      else             { h1 = baseSize * d.scale; w1 = h1 * aspect; }

      if (axis === "x") {
        const refHalfW = (w1 * scaleRatio) / 2;
        if (refHalfW > 0) {
          d.scaleX = Math.min(2, Math.max(0.3, Math.abs(localX) / refHalfW));
        }
      } else {
        const refHalfH = (h1 * scaleRatio) / 2;
        if (refHalfH > 0) {
          d.scaleY = Math.min(2, Math.max(0.3, Math.abs(localY) / refHalfH));
        }
      }

      syncIfSame(d); redraw();
      setStretchUI(axis === "x" ? d.scaleX : d.scaleY);
    }

    handle.addEventListener("mousedown", e => { e.stopPropagation(); e.preventDefault(); if (!getDesign()) return; resizing = true; }, { signal });
    window.addEventListener("mousemove", e => { if (resizing) doResize(e.clientX, e.clientY); }, { signal });
    window.addEventListener("mouseup", () => { resizing = false; }, { signal });
    handle.addEventListener("touchstart", e => { e.stopPropagation(); e.preventDefault(); if (!getDesign()) return; resizing = true; }, { passive: false, signal });
    window.addEventListener("touchmove", e => { if (!resizing) return; doResize(e.touches[0].clientX, e.touches[0].clientY); }, { signal });
    window.addEventListener("touchend", () => { resizing = false; }, { signal });
  }

  // ─────────────────────────────────────────
  // GENERATE MERGED IMAGE
  // ─────────────────────────────────────────
  function generateMergedImage(baseImgSrc, designState, canvasEl, explicitZone, mimeType) {
    mimeType = mimeType || "image/png";
    const jpegQuality = mimeType === "image/jpeg" ? 0.92 : undefined;
    return new Promise((resolve, reject) => {
      if (!designState || !designState.img) return resolve(null);
      const offscreen = document.createElement("canvas");
      offscreen.width = 800; offscreen.height = 800;
      const ctx = offscreen.getContext("2d");
      const baseImg = new Image();
      baseImg.crossOrigin = "anonymous";

      baseImg.onload = () => {
        if (mimeType === "image/jpeg") {
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, 800, 800);
        }
        ctx.drawImage(baseImg, 0, 0, 800, 800);
        const zone = explicitZone || canvasEl._zone;
        const zoneX = (zone.left   / 100) * 800;
        const zoneY = (zone.top    / 100) * 800;
        const zoneW = (zone.width  / 100) * 800;
        const zoneH = (zone.height / 100) * 800;
        const { img, x, y, scale, rotation } = designState;
        const sx = designState.scaleX != null ? designState.scaleX : 1;
        const sy = designState.scaleY != null ? designState.scaleY : 1;
        const ratio    = zoneW / canvasEl.width;
        const baseSize = canvasEl.width * 0.8 * ratio;
        const aspect   = img.width / img.height;
        let w, h;
        if (aspect >= 1) { w = baseSize * scale; h = w / aspect; }
        else             { h = baseSize * scale; w = h * aspect; }
        w *= sx;
        h *= sy;
        const cx = zoneX + x * zoneW;
        const cy = zoneY + y * zoneH;
        ctx.save();
        ctx.beginPath(); ctx.rect(zoneX, zoneY, zoneW, zoneH); ctx.clip();
        ctx.translate(cx, cy);
        ctx.rotate(rotation * Math.PI / 180);
        ctx.drawImage(img, -w / 2, -h / 2, w, h);
        ctx.restore();
        offscreen.toBlob(blob => { if (blob) resolve(blob); else reject(new Error("Canvas toBlob failed")); }, mimeType, jpegQuality);
      };

      baseImg.onerror = () => {
        ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, 800, 800);
        if (designState?.img) {
          const img = designState.img;
          const aspect = img.width / img.height;
          let w = 600, h = 600;
          if (aspect >= 1) { h = w / aspect; } else { w = h * aspect; }
          ctx.drawImage(img, (800 - w) / 2, (800 - h) / 2, w, h);
        }
        offscreen.toBlob(blob => resolve(blob), mimeType, jpegQuality);
      };

      baseImg.src = proxyUrl(sanitizeImgUrl(baseImgSrc));
    });
  }

  // ─────────────────────────────────────────
  // CONVERT THE RAW UPLOADED DESIGN TO THE REQUIRED EXPORT FORMAT
  // ─────────────────────────────────────────
  function imageToFormat(img, mimeType) {
    mimeType = mimeType || "image/png";
    const jpegQuality = mimeType === "image/jpeg" ? 0.95 : undefined;
    return new Promise((resolve, reject) => {
      if (!img) return resolve(null);
      const c = document.createElement("canvas");
      c.width  = img.naturalWidth  || img.width;
      c.height = img.naturalHeight || img.height;
      const ctx = c.getContext("2d");
      if (mimeType === "image/jpeg") {
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, c.width, c.height);
      }
      ctx.drawImage(img, 0, 0, c.width, c.height);
      c.toBlob(blob => { if (blob) resolve(blob); else reject(new Error("toBlob failed")); }, mimeType, jpegQuality);
    });
  }

  // ─────────────────────────────────────────
  // SAVE & ADD TO CART
  // ─────────────────────────────────────────
  function handleSave(popup, mode, canvas, activeTab, frontImg, backImg, easifyOpts, zones, SHRINK_W, SHRINK_H, OFFSET_X, OFFSET_Y, exportMime, exportExt) {
    if (popup.dataset.locked === "1") return;

    exportMime = exportMime || "image/png";
    exportExt  = exportExt  || "png";

    const saveBtn = popup.querySelector("#saveDesign");
    const notes   = popup.querySelector("#designNotes").value;

    const frontPrint = !!designs.front?.file;
    const backPrint  = !!designs.back?.file;

    if (!frontPrint && !backPrint) {
      alert("Please upload a design file first.");
      return;
    }

    const variantInput = document.querySelector('form[action="/cart/add"] [name="id"]');
    if (!variantInput) {
      alert("Please select a size / colour first.");
      return;
    }

    popup.dataset.locked = "1";
    saveBtn.disabled = true;
    saveBtn.textContent = "Uploading…";

    function uploadBlob(blob, filename) {
      if (!blob) return Promise.resolve(null);
      const formData = new FormData();
      formData.append("file", blob, filename);
      formData.append("upload_preset", "shop_upload");
      return fetch("https://api.cloudinary.com/v1_1/deatmowdc/image/upload", { method: "POST", body: formData })
        .then(r => r.json())
        .then(data => { if (!data.secure_url) throw new Error("Upload failed"); return data.secure_url; });
    }

    const cleanFrontImg = sanitizeImgUrl(frontImg);
    const cleanBackImg  = sanitizeImgUrl(backImg);

    function getShrunkZone(rawZone) {
      return {
        width:  rawZone.width  * SHRINK_W,
        height: rawZone.height * SHRINK_H,
        left:   rawZone.left + (rawZone.width  - rawZone.width  * SHRINK_W) / 2 + OFFSET_X,
        top:    rawZone.top  + (rawZone.height - rawZone.height * SHRINK_H) / 2 + OFFSET_Y
      };
    }

    const frontMergePromise = frontPrint ? generateMergedImage(cleanFrontImg, designs.front, canvas, getShrunkZone(zones.front), exportMime) : Promise.resolve(null);
    const backMergePromise  = backPrint  ? generateMergedImage(cleanBackImg,  designs.back,  canvas, getShrunkZone(zones.back || zones.front), exportMime) : Promise.resolve(null);

    const sameFile = designs.front?.file && designs.back?.file && designs.front.file === designs.back.file;

   Promise.all([frontMergePromise, backMergePromise])
      .then(([frontBlob, backBlob]) => {
        const frontRawPromise  = designs.front?.img
          ? imageToFormat(designs.front.img, exportMime).then(blob => uploadBlob(blob, `front-design.${exportExt}`))
          : Promise.resolve(null);
        const backRawPromise   = sameFile
          ? frontRawPromise
          : (designs.back?.img
              ? imageToFormat(designs.back.img, exportMime).then(blob => uploadBlob(blob, `back-design.${exportExt}`))
              : Promise.resolve(null));
        const frontBlobPromise = uploadBlob(frontBlob, `front-preview.${exportExt}`);
        const backBlobPromise  = uploadBlob(backBlob, `back-preview.${exportExt}`);
        return Promise.all([frontRawPromise, backRawPromise, frontBlobPromise, backBlobPromise]);
      })
      .then(([frontRawUrl, backRawUrl, frontPreviewUrl, backPreviewUrl]) => {

        const placement = {
          front: designs.front ? { x: designs.front.x, y: designs.front.y, scale: designs.front.scale, scaleX: designs.front.scaleX, scaleY: designs.front.scaleY, rotation: designs.front.rotation } : null,
          back:  designs.back  ? { x: designs.back.x,  y: designs.back.y,  scale: designs.back.scale,  scaleX: designs.back.scaleX,  scaleY: designs.back.scaleY,  rotation: designs.back.rotation  } : null
        };

        let printSideLabel = "None";
        if (frontPrint && backPrint) printSideLabel = "Both";
        else if (frontPrint)         printSideLabel = "Front";
        else if (backPrint)          printSideLabel = "Back";

        const productForm = document.querySelector('form[action="/cart/add"]');

        function injectHidden(name, value) {
          const existing = productForm.querySelector(`input[name="${name}"]`);
          if (existing) { existing.value = value; return; }
          const inp = document.createElement("input");
          inp.type  = "hidden";
          inp.name  = `properties[${name}]`;
          inp.value = value;
          productForm.appendChild(inp);
        }

        injectHidden("_Front_Design_File",   frontRawUrl     || "");
        injectHidden("_Back_Design_File",     backRawUrl      || "");
        injectHidden("_Front_Preview_Image",  frontPreviewUrl || "");
        injectHidden("_Back_Preview_Image",   backPreviewUrl  || "");
        injectHidden("Print Side",            printSideLabel);
        injectHidden("Design Notes",          notes);
        injectHidden("_Placement",            JSON.stringify(placement));

        saveBtn.textContent = "Adding to cart…";

        const designKey = variantInput.value;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              [`design_front_design_${designKey}`]:   frontRawUrl     || "",
              [`design_back_design_${designKey}`]:    backRawUrl      || "",
              [`design_front_preview_${designKey}`]:  frontPreviewUrl || "",
              [`design_back_preview_${designKey}`]:   backPreviewUrl  || "",
              [`design_print_side_${designKey}`]:     printSideLabel,
              [`design_notes_${designKey}`]:          notes
            }
          })
        })
        .catch(err => console.error("cart attribute save failed", err))
        .then(() => {
          setTimeout(() => {
            const atcBtn = productForm.querySelector('[type="submit"], .btn-addtocart, #AddToCart, [name="add"]');

            if (atcBtn) {
              atcBtn.click();

              setTimeout(() => {
                popup.remove();

                const drawer = document.querySelector("#CartDrawer, .cart-drawer, #CartContainer");
                if (drawer) {
                  drawer.classList.add("is-loading");
                }
              }, 1200);

            } else {
              fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  items: [{
                    id: variantInput.value,
                    quantity: 1,
                    properties: {
                      "_Front_Design_File": frontRawUrl || "",
                      "_Back_Design_File": backRawUrl || "",
                      "_Front_Preview_Image": frontPreviewUrl || "",
                      "_Back_Preview_Image": backPreviewUrl || "",
                      "Print Side": printSideLabel,
                      "Design Notes": notes,
                      "_Placement": JSON.stringify(placement)
                    }
                  }]
                })
              })
              .then(r => r.json())
              .then(() => {
                popup.remove();
              })
              .catch(err => {
                console.error(err);
                alert("Something went wrong. Please try again.");
              });
            }
          }, 600);
        });
      })
      .catch(err => {
        console.error(err);
        alert("Something went wrong. Please try again.");
        popup.dataset.locked = "0";
        saveBtn.disabled = false;
        saveBtn.innerHTML = cartSVG + " Save &amp; Add to Cart";
      });
  }

  // ─────────────────────────────────────────
  // GET CURRENT VARIANT IMAGES
  // ─────────────────────────────────────────
  function getCurrentVariantImages() {
    const activeThumb   = document.querySelector('.product__thumbs .slick-slide.slick-current .product__thumb');
    const activeMainImg = document.querySelector('.product__main-photos .slick-slide.slick-current .photoswipe__image');
    let currentSrc = null;
    if (activeThumb) currentSrc = activeThumb.getAttribute('href');
    else if (activeMainImg) currentSrc = activeMainImg.getAttribute('data-photoswipe-src') || activeMainImg.src;
    if (!currentSrc) return null;
    let frontUrl = currentSrc, backUrl = currentSrc;
    if (currentSrc.includes('/front-')) { frontUrl = currentSrc; backUrl = currentSrc.replace('/front-', '/back-'); }
    else if (currentSrc.includes('/back-')) { backUrl = currentSrc; frontUrl = currentSrc.replace('/back-', '/front-'); }
    return { front: frontUrl, back: backUrl };
  }

  function bindDesignButtons(selector, mode) {
    document.querySelectorAll(selector).forEach(b =>
      b.addEventListener("click", e => {
        e.preventDefault();
        const imgs = getCurrentVariantImages();
        if (imgs) { b.setAttribute("data-front", imgs.front); b.setAttribute("data-back", imgs.back); }
        openPopup(b, mode);
      })
    );
  }

  bindDesignButtons(".pyd-btn-front", "front");
  bindDesignButtons(".pyd-btn-back",  "back");
  bindDesignButtons(".pyd-btn-both, .pyd-btn", "both");

});